var cov_k32sio7mq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/context.tsx",
      hash = "8ed06d9662b92575d34f826e08c6b71dd1986eba",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 68
        }
      },
      "1": {
        start: {
          line: 7,
          column: 21
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "2": {
        start: {
          line: 10,
          column: 24
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "3": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 106
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "5": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 15,
          column: 13
        }
      },
      "6": {
        start: {
          line: 14,
          column: 35
        },
        end: {
          line: 14,
          column: 105
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 12,
            column: 26
          }
        },
        loc: {
          start: {
            line: 12,
            column: 106
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 106
          },
          end: {
            line: 12,
            column: 107
          }
        },
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 15,
            column: 13
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 14,
            column: 5
          },
          end: {
            line: 14,
            column: 6
          }
        },
        loc: {
          start: {
            line: 14,
            column: 35
          },
          end: {
            line: 14,
            column: 105
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Menu/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_k32sio7mq.s[0]++, createReactContext({}));

var _ref = (cov_k32sio7mq.s[1]++, context),
    Consumer = _ref.Consumer; // eslint-disable-next-line


export var Provider = (cov_k32sio7mq.s[2]++, context.Provider);
cov_k32sio7mq.s[3]++;
export var consumer = function consumer(Origin) {
  cov_k32sio7mq.f[0]++;
  cov_k32sio7mq.s[4]++;
  return function (props) {
    cov_k32sio7mq.f[1]++;
    cov_k32sio7mq.s[5]++;
    return (
      /*#__PURE__*/
      React.createElement(Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 3
        }
      }, function (_ref2) {
        var bindItem = _ref2.bindItem,
            unbindItem = _ref2.unbindItem;
        cov_k32sio7mq.f[2]++;
        cov_k32sio7mq.s[6]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            unbindItem: unbindItem,
            bindItem: bindItem,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 14,
              columnNumber: 36
            }
          }))
        );
      })
    );
  };
};